import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import config from '../config';
import user from './user';
import followees from './followees';
import payment from './payment';
import trainingPlans from './trainingPlans';
import activityTypes from './activityTypes';
import activities from './activities';
import app from './app';
import dataImports from './dataImports';
import athleteHomeIntroWithActivities from './athleteHomeIntroWithActivities';
import notices from './notices';
import archives from './archives';
import calendar from './calendar';
import member from './member';
import tmp from './tmp';

Vue.use(Vuex);

export default new Vuex.Store({
  strict: config.Node !== 'production',
  modules: {
    app,
    user,
    member,
    followees,
    payment,
    trainingPlans,
    activityTypes,
    activities,
    dataImports,
    athleteHomeIntroWithActivities,
    notices,
    archives,
    calendar,
    tmp,
  },
  getters: {
    ready: (store, getters) => getters.calendar.length > 0,
    isNative: () => window.platform !== undefined,
  },
  actions: {
    // This action changes state from multiple
    // modules. Maybe there is a better way to do it than have
    // it here?
    clearAll() {
      return Promise.all([
        this.dispatch('clearApp'),
        this.dispatch('clearUser'),
        this.dispatch('clearFollowees'),
        this.dispatch('clearTrainingPlans'),
        this.dispatch('clearActivityTypes'),
        this.dispatch('clearActivities'),
        this.dispatch('athleteHomeIntroWithActivities/clearRefs'),
        this.dispatch('clearDataImports'),
        this.dispatch('clearArchivedActivities'),
        this.dispatch('clearCalendar'),
        this.commit('clearMember'),
      ]);
    },
    async initialize() {
      if (this.getters.loggedInMember) {
        if (this.getters.isNative
          && this.getters.hasRefreshTokens
          && this.getters.tokensExpired()
        ) {
          try {
            await this.dispatch('refreshToken');
          } catch (e) {
            console.log(e);
            return;
          }
        }
        this.commit('clearDataImports');
      }
    },
    async loadData(context) {
      await Promise.all([
        this.dispatch('refreshMember'),
        this.dispatch('generateRandomMessageIndex'),
      ]);
    },
  },
  plugins: [
    createPersistedState({
      paths: [
        'app', 'user', 'member', 'followees', 'payment', 'activityTypes', 'dataImports',
        'athleteHomeIntroWithActivities', 'notices',
      ],
    }),
  ],
});
